import styled from 'styled-components'

import { DtDrawer, type DrawerControlProps } from '@root/shared/ui-kit'

import { TradeSettings } from './trade-settings'

import type { TradeSettingsFormProps } from '@root/widgets/trade/trade-settings/desktop'

type Props = DrawerControlProps & TradeSettingsFormProps

export const TradeSettingsDrawer: React.FC<Props> = ({
  className,
  open,
  onOpenChange,
  ...formProps
}) => {
  return (
    <Root overlay className={className} open={open} onOpenChange={onOpenChange}>
      <TradeSettings
        {...formProps}
        onSaved={(settings) => {
          formProps.onSaved?.(settings)
          onOpenChange?.(false)
        }}
        onClose={() => onOpenChange?.(false)}
      />
    </Root>
  )
}

const Root = styled(DtDrawer)`
  padding-inline: 10px;
  padding-block: 10px;
  background: var(--background-1);
  align-items: start;
  width: 380px;
  padding-top: calc(var(--title-bar-height) + 55px);
  padding-bottom: 34px;
  overflow: hidden;
`
